<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="procedure_patients"
      endpoint="/procedurepatients"
      action-path="/treatment"
      action-label="Treatment"
      no-permission-text="You have no permission to View Procedure Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Procedure Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Procedure Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Procedure Patients", active: true }],
    };
  },
};
</script>
